import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import HostListPage from './pages/hosts/HostListPage';
import HostFormPage from './pages/hosts/HostFormPage';
import EditHostPage from './pages/hosts/EditHostPage';
import ServerListPage from './pages/servers/ServerListPage';
import ServerFormPage from './pages/servers/ServerFormPage';
import EditServerPage from './pages/servers/EditServerPage';
import BackupListPage from './pages/backups/BackupListPage';
import CreateBackupPage from './pages/backups/CreateBackupPage';
import ScheduleBackupPage from './pages/backups/ScheduleBackupPage';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/hosts" element={<HostListPage />} />
          <Route path="/hosts/new" element={<HostFormPage />} />
          <Route path="/hosts/edit/:id" element={<EditHostPage />} />
          <Route path="/servers" element={<ServerListPage />} />
          <Route path="/servers/new" element={<ServerFormPage />} />
          <Route path="/servers/edit/:id" element={<EditServerPage />} />
          <Route path="/backups" element={<BackupListPage />} />
          <Route path="/backups/new" element={<CreateBackupPage />} />
          <Route path="/backups/schedule" element={<ScheduleBackupPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
